import { Moment } from 'moment';
import { ICrudState } from 'redux/reducers/crud';
import { IContact } from './contact';
import { IExpense } from './expenses';
import { INotification } from './notification';
import { IShift } from './shift';

export interface IInvoice {
  // key: number;
  id: string;
  contact: IContact;
  client_display_phone: string;
  date: Moment;
  dueDate: Moment;
  totalExclGst: number;
  totalInclGst: number;
  totalGst: number;
  paidExclGst: number;
  paidInclGst: number;
  writtenOffExclGst: number;
  writtenOffInclGst: number;
  outstandingExclGst: number;
  outstandingInclGst: number;
  total: number;
  code: string;
  status: InvoiceStatus;
  shifts: IShift[];
  idContact?: string;
  expenses: IExpense[];

  expanded: boolean;
  invoiceStatus: string;

  notifications: INotification[];
  receipts: IInvoicePayment[];
}

export interface IInvoiceState extends ICrudState {
  paymentSuccess: boolean;
  reload: boolean;
}

export enum ReceiptType {
  InvoiceReceipt = 'InvoiceReceipt',
  InvoiceWriteOff = 'InvoiceWriteOff',
}

export const getReceiptTypeDisplay = (value: string | ReceiptType) => {
  switch (value) {
    case ReceiptType.InvoiceReceipt:
      return 'Payment';
    case ReceiptType.InvoiceWriteOff:
      return 'Write-off';
  }
  return value;
};

export enum PaymentMethod {
  EFT = 'EFT',
  Cash = 'Cash',
  Other = 'Other',
}

export interface IInvoicePayment {
  id: string;
  receiptType: ReceiptType;
  idInvoice: string;
  date: Moment;
  amountExclGst: number;
  paymentMethod: PaymentMethod;
  otherPaymentMethod: string;
  notes: string;

  amountInclGst: number;
  amountGst: number;

  // Not related but needed for modal
  amountOutstandingInclGst?: number;
}

export enum InvoiceStatus {
  Unpaid = 'Unpaid',
  Paid = 'Paid',
  WrittenOff = 'Written-off',

  // Not persistent
  All = 'All statuses',
  Overdue = 'Overdue',
  Today = 'Today',
}
